/* @generated from adl module ferovinum.datacontracts.productstockdetail */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface ProductStockDetailRawRecord {
  id: common_strings.StringNE;
  refJson: common_strings.StringNE;
  batchNumber: (string|null);
  bestBeforeDate: (common.LocalDate|null);
  rotationNumber: (string|null);
  rotationLine: (string|null);
  quantity: common.BigDecimal;
  dutyPaid: (boolean|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeProductStockDetailRawRecord(
  input: {
    id: common_strings.StringNE,
    refJson: common_strings.StringNE,
    batchNumber: (string|null),
    bestBeforeDate: (common.LocalDate|null),
    rotationNumber: (string|null),
    rotationLine: (string|null),
    quantity: common.BigDecimal,
    dutyPaid: (boolean|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): ProductStockDetailRawRecord {
  return {
    id: input.id,
    refJson: input.refJson,
    batchNumber: input.batchNumber,
    bestBeforeDate: input.bestBeforeDate,
    rotationNumber: input.rotationNumber,
    rotationLine: input.rotationLine,
    quantity: input.quantity,
    dutyPaid: input.dutyPaid,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const ProductStockDetailRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.productstockdetail","decl":{"annotations":[{"value":{"datasetName":"raw_product_stock_detail"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"refJson","default":{"kind":"nothing"},"name":"refJson","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"batchNumber","default":{"kind":"nothing"},"name":"batchNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"bestBeforeDate","default":{"kind":"nothing"},"name":"bestBeforeDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"rotationNumber","default":{"kind":"nothing"},"name":"rotationNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"rotationLine","default":{"kind":"nothing"},"name":"rotationLine","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"dutyPaid","default":{"kind":"nothing"},"name":"dutyPaid","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ProductStockDetailRawRecord","version":{"kind":"nothing"}}};

export const snProductStockDetailRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.productstockdetail", name:"ProductStockDetailRawRecord"};

export function texprProductStockDetailRawRecord(): ADL.ATypeExpr<ProductStockDetailRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snProductStockDetailRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.productstockdetail.ProductStockDetailRawRecord" : ProductStockDetailRawRecord_AST
};
